<template>
  <div>
    <v-slide-x-reverse-transition>
      <v-alert type="success" class="alert_success" v-if="alert_show_edit === true">แก้ไขการตั้งค่าข้อมูลร้านอาหารเรียบร้อย</v-alert>
      <v-alert type="error" class="alert_success" v-if="alert_show_error === true">{{text_error}}</v-alert>
    </v-slide-x-reverse-transition>
    <div class="d-flex justify-space-between mb-2">
      <div class="d-flex justify-center align-center">
        <div class="img_title_setting_restaurant">
          <img src="@/assets/icon-restaurant-settingshop.png">
        </div>
        <h2 class="title_setting_restaurant">ตั้งค่าข้อมูลร้านอาหาร</h2>
      </div>
      <v-btn class="white--text grad-primary-bg" height="50" width="20%" @click="$router.push('/restaurant')">
        ย้อนกลับ
      </v-btn>
    </div>
    <div v-if="loading_page === true">
      <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
        <v-skeleton-loader type="article, actions"></v-skeleton-loader>
      </v-sheet>
    </div>
    <div v-if="loading_page === false">
      <v-form ref="form_edit" @submit.prevent="editSettingRestaurant()">
        <v-card class="mb-3">
          <v-container>
            <v-row>
              <v-col cols="12">
                <h3>
                  ข้อมูลพื้นฐาน
                </h3>
              </v-col>

              <v-col cols="6">
                <v-text-field label="ชื่อร้าน (ภาษาไทย)" hide-details="auto" :rules="[v => !!v || 'กรุณากรอกชื่อร้าน (ภาษาไทย)']" required v-model="name_restaurant_th" outlined></v-text-field>
              </v-col>
              <v-col cols="6">
                <v-text-field label="ชื่อร้าน (ภาษาอังกฤษ)" hide-details="auto" :rules="[v => !!v || 'กรุณากรอกชื่อร้าน (ภาษาอังกฤษ)']" required v-model="name_restaurant_eng" outlined></v-text-field>
              </v-col>

              <v-col cols="12">
                <v-textarea outlined label="ที่อยู่" hide-details="auto" v-model="address"></v-textarea>
              </v-col>

              <v-col cols="6">
                <v-text-field label="เบอร์โทร" hide-details="auto" @keypress="check_phone_number($event, tel)" :rules="[v => !!v || 'กรุณากรอกเบอร์โทร']" required v-model="tel" outlined></v-text-field>
              </v-col>
              <v-col cols="6">
                <v-text-field label="เลขที่ผู้ภาษี" hide-details="auto"  v-model="tax_number" outlined></v-text-field>
              </v-col>

              <v-col cols="12">
                <h3>
                  ธีมสีสำหรับการแสดงรูปแบบในการสั่งอาหารของลูกค้า
                </h3>
              </v-col>

              <v-col cols="12">
                <div class="d-flex align-center">
                  <div class="d-flex align-center">
                    <div class="mr-1">สามารถเลือกรหัสสีได้ที่นี่</div>
                    <v-input-colorpicker v-model="color_code" class="colorpicker_setting_restaurant" />
                  </div>
                  <div class="ml-2 input_color_setting_restaurant">
                    <v-text-field label="รหัสสี" hide-details="auto" :rules="[v => !!v || 'กรุณากรอกรหัสสี']" required v-model="color_code" outlined></v-text-field>
                  </div>
                </div>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
        <v-card class="mb-3">
          <v-container>
            <v-row>
              <v-col cols="12">

                <h3 class="mb-2">จัดการภาษี</h3>

                <div class="vat_detail_setting_restaurant">
                  <div class="mr-1">
                    <div>ทานที่ร้าน</div>
                    <v-radio-group class="mt-0" v-model="vat_a_la_carte" hide-details="auto" :rules="[v => !!v || 'กรุณาเลือก Vat 7% รวมค่าอาหารหรือไม่']" required>
                      <div class="d-flex">
                        <v-radio value="0"></v-radio>
                        <div class="mr-1">Vat 7% รวมค่าอาหาร</div>
                      </div>
                      <div class="d-flex">
                        <v-radio value="1"></v-radio>
                        <div class="mr-1">Vat 7% ไม่รวมค่าอาหาร</div>
                      </div>
                      <div class="d-flex">
                        <v-radio value="2"></v-radio>
                        <div class="mr-1">ไม่มี Vat 7%</div>
                      </div>
                    </v-radio-group>
                    <div class="service_charge_name_setting_restaurant">
                      <v-checkbox label="Service Charge(หน้าร้าน)" class="mt-0 mr-2 mb-2" v-model="check_service_charge_a_la_carte" hide-details="auto" />
                    </div>
                    <div>
                      <v-select label="เปอร์เซนต์ 1-10%" :items="service_charge_list" item-text="name" item-value="id" v-model="service_charge_a_la_carte" hide-details="auto" outlined :disabled="check_service_charge_a_la_carte === true ? false : true" v-if="!check_service_charge_a_la_carte"></v-select>

                      <v-select label="เปอร์เซนต์ 1-10%" :items="service_charge_list" item-text="name" item-value="id" v-model="service_charge_a_la_carte" hide-details="auto" :rules="[v => !!v || 'กรุณาเลือกเปอร์เซนต์']" required outlined v-if="check_service_charge_a_la_carte"></v-select>
                    
                    </div>

                    <div class="service_charge_name_setting_restaurant_take_away">
                      <v-checkbox label="Service Charge(กลับบ้าน)" class="mt-0 mr-2 mb-2" v-model="check_service_charge_take_away" hide-details="auto" />
                    </div>
                    <div>
                      <v-select label="เปอร์เซนต์ 1-10%" :items="service_charge_list" item-text="name" item-value="id" v-model="service_charge_a_la_carte_take_away" hide-details="auto" outlined :disabled="check_service_charge_take_away === true ? false : true" v-if="!check_service_charge_take_away"></v-select>

                      <v-select label="เปอร์เซนต์ 1-10%" :items="service_charge_list" item-text="name" item-value="id" v-model="service_charge_a_la_carte_take_away" hide-details="auto" :rules="[v => !!v || 'กรุณาเลือกเปอร์เซนต์']" required outlined v-if="check_service_charge_take_away"></v-select>
                    
                    </div>

                    <div class="service_charge_name_setting_restaurant_express">
                      <v-checkbox label="Service Charge(สั่งอาหารด่วน)" class="mt-0 mr-2 mb-2" v-model="check_service_charge_express" hide-details="auto" />
                    </div>
                    <div>
                      <v-select label="เปอร์เซนต์ 1-10%" :items="service_charge_list" item-text="name" item-value="id" v-model="service_charge_a_la_carte_express" hide-details="auto" outlined :disabled="check_service_charge_express === true ? false : true" v-if="!check_service_charge_express"></v-select>

                      <v-select label="เปอร์เซนต์ 1-10%" :items="service_charge_list" item-text="name" item-value="id" v-model="service_charge_a_la_carte_express" hide-details="auto" :rules="[v => !!v || 'กรุณาเลือกเปอร์เซนต์']" required outlined v-if="check_service_charge_express"></v-select>
                    
                    </div>
                  </div>
                </div>

              </v-col>
            </v-row>
          </v-container>
        </v-card>
        <v-card class="mb-3">
          <v-container>
            <v-row>
              <v-col cols="12">

                <h3 class="mb-2">เวลาทำการ</h3>

                <div>
                  <div>วันเปิดทำการ</div>
                  <div class="d-flex">
                    <div v-for="(data, index) in working_days" :key="index">
                      <div class="mr-2">
                        <v-checkbox :label="data.day_name" class="mt-0 mb-2" hide-details="auto" v-model="data.status_ckecked" />
                      </div>
                    </div>
                  </div>
                  <div>เวลาเปิด-ปิด</div>
                  <div class="d-flex align-center">
                    <div class="mr-1">
                      <vue-timepicker placeholder="เวลาเปิด" v-model="time_open"></vue-timepicker>
                      <!-- <v-text-field label="เวลาเปิด" hide-details="auto" :rules="[v => !!v || 'กรุณากรอกเวลาเปิด']" required v-model="time_open" outlined></v-text-field> -->
                    </div>
                    <div class="ml-1 mr-1">ถึง</div>
                    <div class="ml-1">
                      <vue-timepicker placeholder="เวลาปิด" v-model="time_close"></vue-timepicker>
                      <!-- <v-text-field label="เวลาปิด" hide-details="auto" :rules="[v => !!v || 'กรุณากรอกเวลาปิด']" required v-model="time_close" outlined></v-text-field> -->
                    </div>
                  </div>
                </div>

              </v-col>
            </v-row>
          </v-container>
        </v-card>
        <v-card class="mb-3">
          <v-container>
            <v-row>
              <v-col cols="12">
                <h3>
                  โลโก้
                </h3>
              </v-col>
              <v-col cols="4">
                <div class="example_image_logo_setting_restaurant border_image_example">
                  <img src="@/assets/example_print_step1.png">
                </div>
                <div class="example_image_logo_setting_restaurant border_image_example">
                  <img src="@/assets/example_print_step2.png">
                </div>
                <div class="example_image_logo_setting_restaurant border_image_example">
                  <img src="@/assets/example_print_step3.png">
                </div>
              </v-col>
              <v-col cols="8">
                <div>
                  <div>
                    รูปภาพโลโก้สำหรับแสดงในหน้าการสั่งอาหารของลูกค้า
                  </div>
                  <v-img height="220" max-width="220" v-if="imagePreviewURLColor" :src="imagePreviewURLColor"></v-img>
                  <div>
                    <v-file-input prepend-icon="mdi-file-upload-outline" accept="image/*" v-model="picture_one" label="เพิ่มรูปภาพโลโก้" @change="onFileChangeColor"></v-file-input>
                    <div class="error--text">
                      ขนาดแนะนำ : 500 x 500 px หรือขนาดสี่เหลี่ยมจัตุรัส<br>
                      ไฟล์ภาพ : .png<br>
                      เพื่อความสวยงามแนะนำภาพไม่มีพื้นหลัง
                    </div>
                  </div>
                </div>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
        <v-card class="mb-3">
          <v-container>
            <v-row>
              <v-col cols="12">
                <h3>
                  โลโก้ สำหรับการพิมพ์ใบเสร็จ
                </h3>
              </v-col>
              <v-col cols="4">
                <div class="example_image_logo_setting_restaurant">
                  <img src="@/assets/example_print_slip.png">
                </div>
              </v-col>
              <v-col cols="8">
                <div>
                  <div>
                    รูปภาพโลโก้สำหรับการพิมพ์ใบเสร็จรับเงิน (รูปภาพสีขาว-ดำ)
                  </div>
                  <v-img height="220" max-width="220" v-if="imagePreviewURLBlackWhite" :src="imagePreviewURLBlackWhite"></v-img>
                  <div>
                    <v-file-input prepend-icon="mdi-file-upload-outline" accept="image/*" v-model="picture_two" label="เพิ่มรูปภาพโลโก้ สำหรับพิมพ์ใบเสร็จ" @change="onFileChangeBlackWhite"></v-file-input>
                    <div class="error--text">
                      ขนาดแนะนำ : 250 x 250 px หรือขนาดสี่เหลี่ยมจัตุรัส<br>
                      ไฟล์ภาพ : .png<br>
                      เพื่อความสวยงามแนะนำภาพไม่มีพื้นหลัง
                    </div>
                  </div>
                </div>
              </v-col>

            </v-row>

          </v-container>
        </v-card>

        <v-card class="mb-3">
          <v-container>
            <v-row>
              <v-col cols="12">
                <div class="d-flex justify-space-between align-center">
                  <h3>
                    Qr Code สำหรับการสแกนจ่ายเงินท้ายใบเสร็จ
                  </h3>
                  <div class="d-inline-block">
                    <v-switch color="primary" :label="qr_code_pay_show != 1 || qr_code_pay_show != true ? 'ปิดการแสดง Qr Code จ่ายเงินท้ายใบเสร็จ' : 'เปิดการแสดง Qr Code จ่ายเงินท้ายใบเสร็จ'" class="ma-0 pa-0" v-model="qr_code_pay_show" hide-details></v-switch>
                  </div>
                </div>
              </v-col>
              <v-col cols="4">
                <div class="example_image_logo_setting_restaurant">
                  <img src="@/assets/barcode_image.png">
                </div>
              </v-col>
              <v-col cols="8">
                <div>
                  <div>
                    รูปภาพ Qr Code สำหรับการสแกนจ่ายเงินท้ายใบเสร็จ
                  </div>
                  <v-img height="220" max-width="220" v-if="imagePreviewURLBarCode" :src="imagePreviewURLBarCode"></v-img>
                  <div>
                    <v-file-input prepend-icon="mdi-file-upload-outline" accept="image/*" v-model="picture_three" label="เพิ่มรูปภาพ Qr Code สำหรับการสแกนจ่ายเงินท้ายใบเสร็จ" @change="onFileChangeBarCode"></v-file-input>
                    <div class="error--text">
                      ขนาดแนะนำ : 250 x 250 px หรือขนาดสี่เหลี่ยมจัตุรัส<br>
                      ไฟล์ภาพ : .png<br>
                    </div>
                  </div>
                  <div class="py-3">ข้อมูลบัญชีธนาคาร</div>
                  <div class="grid_half">
                    <div class="pa-2">
                      <v-text-field label="ชื่อบัญชี" v-model="banking_account" outlined></v-text-field>
                    </div>
                  </div>
                  <div class="grid_half">
                    <div class="pa-2">
                      <v-text-field label="ชื่อธนาคาร" v-model="banking_name" outlined></v-text-field>
                    </div>
                    <div class="pa-2">
                      <v-text-field label="เลขบัญชี" v-model="banking_number" outlined></v-text-field>
                    </div>
                  </div>
                </div>
              </v-col>

            </v-row>

          </v-container>
        </v-card>

        <v-card class="mb-3">
          <v-container>
            <v-row>
              <v-col cols="12">
                <h3>แสดงรายการอาหาร (ประเภทอาหาร)</h3>
              </v-col>
              <v-col cols="12">
                <div class="mt-n5 mb-3 d-inline-block">
                  <v-switch color="primary" :label="setting_type_food != 1 || setting_type_food != true ? 'ปิด' : 'เปิด'" v-model="setting_type_food" hide-details></v-switch>
                </div>
              </v-col>
            </v-row>
          </v-container>
        </v-card>

        <v-card class="mb-3">
          <v-container>
            <v-row>
              <v-col cols="12">
                <h3>การตัดวัตถุดิบอัตโนมัติ</h3>
              </v-col>
              <v-col cols="12">
                <div class="mt-n5 mb-3 d-inline-block">
                  <v-switch color="primary" :label="auto_cut_material != 1 || auto_cut_material != true ? 'ปิด' : 'เปิด'" v-model="auto_cut_material" hide-details></v-switch>
                </div>
              </v-col>
            </v-row>
          </v-container>
        </v-card>

        <div class="text-center">
          <v-btn color="#28ab28" class="titlefont_addfood_manage_food white--text" type="submit" height="50" width="40%">
            บันทึกการตั้งค่า
          </v-btn>
        </div>
      </v-form>
    </div>
  </div>
</template>

<script src="@/previewimage.js"></script><script>
import {
  HTTP
} from "@/axios.js"
import before_image_color from "@/assets/example_logo_color.png";
import before_image_blackwhite from "@/assets/example_logo_blackwhite.png";
import barcode_image from "@/assets/example_logo_barcode.png";
import InputColorPicker from 'vue-native-color-picker'
import VueTimepicker from 'vue2-timepicker'
import 'vue2-timepicker/dist/VueTimepicker.css'
import {isTelephone} from "@/helper/helper";
export default {
  name: 'addFood',
  data() {
    return {
      loading_page: true,
      alert_show_edit: false,
      alert_show_error: false,
      text_error: null,
      imagePreviewURLColor: before_image_color,
      imagePreviewURLBlackWhite: before_image_blackwhite,
      imagePreviewURLBarCode: barcode_image,
      name_restaurant_th: null,
      name_restaurant_eng: null,
      auto_cut_material: false,
      status_id: null,
      address: null,
      tel: null,
      tax_number: null,
      color_code: null,
      qr_code_pay_show: false,
      banking_name: null,
      banking_number: null,
      banking_account: null,
      service_charge_list:[
        {
          id:1,
          name:'1%',
        },
        {
          id:2,
          name:'2%',
        },
        {
          id:3,
          name:'3%',
        },
        {
          id:4,
          name:'4%',
        },
        {
          id:5,
          name:'5%',
        },
        {
          id:6,
          name:'6%',
        },
        {
          id:7,
          name:'7%',
        },
        {
          id:8,
          name:'8%',
        },
        {
          id:9,
          name:'9%',
        },
        {
          id:10,
          name:'10%',
        },
      ],
      vat_a_la_carte: '0',
      check_service_charge_a_la_carte: false,
      check_service_charge_take_away: false,
      check_service_charge_express: false,
      service_charge_a_la_carte: null,
      service_charge_a_la_carte_take_away: null,
      service_charge_a_la_carte_express: null,
      time_open: null,
      time_close: null,
      picture_one: null,
      picture_two: null,
      picture_three: null,
      working_days: [],
      setting_type_food: null,
    }
  },
  components: {
    "v-input-colorpicker": InputColorPicker,
    "vue-timepicker": VueTimepicker,
  },
  inject: {
    theme: {
      default: {
        isDark: false
      },
    },
  },
  methods: {
    check_phone_number: function (evt, number) {
      return isTelephone(evt, number)
    },
    async onFileChangeColor(payload) {
      const file = payload
      if (file) {
        this.imagePreviewURLColor = URL.createObjectURL(file)
        URL.revokeObjectURL(file)
      } else {
        this.imagePreviewURLColor = before_image_color
      }

    },
    async onFileChangeBlackWhite(payload) {
      const file = payload
      if (file) {
        this.imagePreviewURLBlackWhite = URL.createObjectURL(file)
        URL.revokeObjectURL(file)
      } else {
        this.imagePreviewURLBlackWhite = before_image_blackwhite
      }

    },
    async onFileChangeBarCode(payload) {
      const file = payload
      if (file) {
        this.imagePreviewURLBarCode = URL.createObjectURL(file)
        URL.revokeObjectURL(file)
      } else {
        this.imagePreviewURLBarCode = barcode_image
      }

    },
    async settingRestaurantDetail() {
      this.loading_page = true
      HTTP.get('/setup/restaurant', {
        headers: {
          "Authorization": `Bearer ${this.$store.state.token}`
        }
      })
          .then((response) => {
            if (response.data.successful === true) {
              this.name_restaurant_th = response.data.setup.name_restaurant_th
              this.name_restaurant_eng = response.data.setup.name_restaurant_eng
              this.address = response.data.setup.address
              this.tel = response.data.setup.tel
              this.tax_number = response.data.setup.tax_number
              this.color_code = response.data.setup.color_code
              this.vat_a_la_carte = response.data.setup.vat_a_la_carte.toString()
              this.check_service_charge_a_la_carte = response.data.setup.check_service_charge_a_la_carte == 1 ? true : false
              this.check_service_charge_take_away = response.data.setup.check_service_charge_a_la_carte_take_away == 1 ? true : false
              this.check_service_charge_express = response.data.setup.check_service_charge_a_la_carte_express == 1 ? true : false
              this.service_charge_a_la_carte = response.data.setup.service_charge_a_la_carte
              this.service_charge_a_la_carte_take_away = response.data.setup.service_charge_a_la_carte_take_away
              this.service_charge_a_la_carte_express = response.data.setup.service_charge_a_la_carte_express
              this.time_open = response.data.setup.time_open
              this.time_close = response.data.setup.time_close
              this.imagePreviewURLColor = response.data.setup.logo1
              this.imagePreviewURLBlackWhite = response.data.setup.logo2
              this.imagePreviewURLBarCode = response.data.setup.logo3
              this.qr_code_pay_show = response.data.setup.logo3_status == 1 ? true : false
              this.banking_account = response.data.setup.banking_account
              this.banking_name = response.data.setup.banking_name
              this.banking_number = response.data.setup.banking_number
              this.working_days = response.data.working_days
              this.status_id = response.data.setup.status_id
              this.auto_cut_material = response.data.setup.status_bom
              this.setting_type_food = response.data.setup.setting_type_food
              this.loading_page = false
            }

          }).catch((error) => {
        if (error.response.status === 401) {
          this.$store.commit('logOutSuccess')
          this.$router.push('/login')
        }
      })
    },
    async editSettingRestaurant() {
      if (this.$refs.form_edit.validate()) {
        this.loading_page = true
        let check_service_charge_a_la_carte = 0
        if (this.check_service_charge_a_la_carte === true) {
          check_service_charge_a_la_carte = 1
        }
        let check_service_charge_take_away = 0
        if (this.check_service_charge_take_away === true) {
          check_service_charge_take_away = 1
        }
        let check_service_charge_express = 0
        if (this.check_service_charge_express === true) {
          check_service_charge_express = 1
        }
        let logo3_status = this.qr_code_pay_show
        if (logo3_status === true) {
          logo3_status = 1
        }
        else if (logo3_status === false) {
          logo3_status = 0
        }
        let bom_status = this.auto_cut_material
        if (bom_status === true) {
          bom_status = 1
        }
        else if (bom_status === false) {
          bom_status = 0
        }
        let setup_type_food = this.setting_type_food
        if (setup_type_food === true) {
          setup_type_food = 1
        }
        else if (setup_type_food === false) {
          setup_type_food = 0
        }
        let data = new FormData()
        data.append('name_restaurant_th', this.name_restaurant_th)
        data.append('name_restaurant_eng', this.name_restaurant_eng)
        data.append('address', this.address)
        data.append('tel', this.tel)
        data.append('tax_number', this.tax_number)
        data.append('color_code', this.color_code)
        data.append('vat_a_la_carte', this.vat_a_la_carte)
        data.append('check_service_charge_a_la_carte', check_service_charge_a_la_carte)
        data.append('check_service_charge_take_away', check_service_charge_take_away)
        data.append('check_service_charge_express', check_service_charge_express)
        data.append('service_charge_a_la_carte', this.service_charge_a_la_carte)
        data.append('service_charge_a_la_carte_take_away', this.service_charge_a_la_carte_take_away)
        data.append('service_charge_a_la_carte_express', this.service_charge_a_la_carte_express)
        data.append('time_open', this.time_open)
        data.append('time_close', this.time_close)
        data.append('logo1', this.picture_one)
        data.append('logo2', this.picture_two)
        data.append('logo3', this.picture_three)
        data.append('logo3_status', logo3_status)
        data.append('banking_account', this.banking_account)
        data.append('banking_name', this.banking_name)
        data.append('banking_number', this.banking_number)
        data.append('status_id', this.status_id)
        data.append('status_bom', bom_status)
        data.append('setting_type_food', setup_type_food)

        this.working_days.forEach((detail) => {
          let statusChecked = 0
          if (detail.status_ckecked == 1 || detail.status_ckecked === true) {
            statusChecked = 1
          }
          data.append('day_id[]', detail.day_id)
          data.append('status_ckecked[]', statusChecked)
        })

        HTTP.post('/setup/restaurant', data, {
          headers: {
            "Authorization": `Bearer ${this.$store.state.token}`
          }
        })
            .then((response) => {
              if (response.data.successful === true) {
                this.picture_one = null
                this.picture_two = null
                this.picture_three = null
                HTTP.get('/lot/create_foodbom',{
                  headers: {
                    "Authorization": `Bearer ${this.$store.state.token}`
                  }
                })
                this.settingRestaurantDetail()
                this.alert_show_edit = true
                setTimeout(() => this.alert_show_edit = false, 5000)
              }
              else {
                this.text_error = response.data.msg
                this.picture_one = null
                this.picture_two = null
                this.picture_three = null
                this.settingRestaurantDetail()
                this.alert_show_error = true
                setTimeout(() => this.alert_show_error = false, 5000)
              }

            }).catch((error) => {
          if (error.response.status === 401) {
            this.$store.commit('logOutSuccess')
            this.$router.push('/login')
          }
        })
      }
    }
  },
  mounted() {
    this.settingRestaurantDetail()
  },
}
</script>

<style scoped>
.title_setting_restaurant {
  margin-left: 10px;
}

.img_title_setting_restaurant {
  width: 50px;
}

.img_title_setting_restaurant>img {
  max-width: 100%;
}

.colorpicker_setting_restaurant {
  width: 55px;
  height: 40px;
}

.input_color_setting_restaurant {
  width: 50%;
}

.example_image_logo_setting_restaurant>img {
  max-width: 100%;
}

.border_image_example {
  border: 2px #eeeeee solid;
  margin: 10px 0;
}

.border_image_example:first-child,
.border_image_example:last-child {
  margin: 0;
}

.vat_detail_setting_restaurant{
  display: grid;
  grid-template-columns: 50% 50%;
}

.service_charge_name_setting_restaurant{
  display: inline-block;
}

.service_charge_name_setting_restaurant_take_away{
  display: inline-block;
}

.service_charge_name_setting_restaurant_express{
  display: inline-block;
}
.vue__time-picker >>> li.active{
  background: rgb(3, 140, 193)!important;
}

.grid_half {
  display: grid;
  grid-template-columns: 50% 50%;
}
</style>
